import throttle from 'lodash/throttle';
import over from 'lodash/over';
import once from 'lodash/once';
import onDelay from './on-delay';
import scroll from './scroll';
import on from './on';
import viewportSize from './viewport-size';



const DELAY = 1000;

export default (callback, asyncInitialCall = false, delay = DELAY) => {
  const body = document.body;
  const trigger = () => {
    const viewportMain = { height: viewportSize.height, width: viewportSize.width };
    const scrollBody = scroll(body);
    const scrollElement = scroll(document.documentElement);

    if (scrollBody.top >= 0 && scrollElement.top === 0) { // NOTE scrollElement for safari browser
      callback(scrollBody, viewportMain);
    } else {
      callback(scrollElement, viewportMain);
    }
  };

  return once(over([
    !asyncInitialCall ? () => {} : onDelay(trigger, 0),
    on(window, 'scroll', throttle(trigger, delay, { leading: false }))
  ]));
};



// WEBPACK FOOTER //
// ./src/lib/dom/on-page-scroll.js